import { type ReactNode, useEffect, useRef, type FC } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "@/assets/icon/Icon";
import { type AddressItem } from "$/utils/fetchGeoData";
import { Pressable } from "@/comps/Pressable";

export const ListItem: FC<{
  item: AddressItem;
  onChange: (val: AddressItem) => void;
  isActived: boolean;
  prefix?: ReactNode;
}> = ({ item, onChange, isActived, prefix }) => {
  const cRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isActived) {
      cRef?.current?.scrollIntoView();
    }
  }, [isActived]);

  return (
    <Pressable
      className={twMerge(
        "border-b-color-border active:bg-color-fill-2 flex h-11 items-center gap-3 border-b px-6",
        isActived ? "text-color-primary" : "",
      )}
      ref={cRef}
      onPress={() => onChange(item)}
      style={{
        scrollMarginTop: 20,
      }}
    >
      {/* prefix 至少一个字符宽度 上下居中对齐 */}
      <div className="min-w-3.5 shrink-0 text-center">{prefix}</div>
      <div className="flex-1 leading-4">{item.name}</div>
      {isActived ? <Icon type="checkArea" className="size-4 shrink-0" /> : null}
    </Pressable>
  );
};
